<template>
    <div class="room-renting-tab">
        <div class="tabulation-title" :style="'color:' + titlesColor">
            <h5>
                {{ index }}.
                <span v-if="!newTitle">
                   Location de salles
                </span>
                <span v-else>
                    {{newTitle}}
                </span>
            </h5>
        </div>

        <v-alert type="info"
                 class="mb-5 form-container mr-auto ml-auto"
                 border="right"
                 :color="primaryColor"
                 colored-border
                 v-if="helpDesc"
        >
            <div>{{helpDesc}}</div>
        </v-alert>

        <div class="form-container mr-auto ml-auto mt-3">
            <div class="tabulation-title m-auto" v-if="hasCapacitiesToDisplay()">
                <h5 style="font-size: 22px" :style="'color:' + titlesColor">
                    Capacités
                </h5>
            </div>

            <div class="mt-5">
                <div v-if="hasField('MAX_CAPACITY_ACC')">
                    <label :style="'color:' + fieldsColor" :class="{'required': getField('MAX_CAPACITY_ACC').required}">
                        {{ getField('MAX_CAPACITY_ACC').name }}
                        <help-tooltip :content="getField('MAX_CAPACITY_ACC').helpDescription"></help-tooltip>
                    </label>
                    <v-text-field
                        v-model="roomRenting.max_capacity"
                        type="number"
                        outlined>
                    </v-text-field>
                </div>

                <div v-if="hasField('ROOM_NUMBER')">
                    <label :style="'color:' + fieldsColor" :class="{'required': getField('ROOM_NUMBER').required}">
                        {{ getField('ROOM_NUMBER').name }}
                        <help-tooltip :content="getField('ROOM_NUMBER').helpDescription"></help-tooltip>
                    </label>
                    <v-text-field
                        v-model="roomRenting.equipped_room_nb"
                        type="number"
                        outlined>
                    </v-text-field>
                </div>

                <div v-if="hasField('ROOM_MOD')">
                    <label :style="'color:' + fieldsColor" :class="{'required': getField('ROOM_MOD').required}">
                        {{ getField('ROOM_MOD').name }}
                        <help-tooltip :content="getField('ROOM_MOD').helpDescription"></help-tooltip>
                    </label>
                    <v-text-field
                        v-model="roomRenting.multi_purpose_room_nb"
                        type="number"
                        outlined>
                    </v-text-field>
                </div>
            </div>

            <div class="tabulation-title m-auto" v-if="hasPrestationsToDisplay()">
                <h5 style="font-size: 22px" :style="'color:' + titlesColor">
                    Prestations
                </h5>
            </div>

            <div class="mt-5">
                <div v-if="hasFamilyElement('SalleEquipeePour')">
                    <label :style="'color:' + fieldsColor" :class="{'required': getField('SalleEquipeePour').required}">
                        {{ getField('SalleEquipeePour').name }}
                        <help-tooltip :content="getField('SalleEquipeePour').helpDescription"></help-tooltip>
                    </label>
                    <v-autocomplete
                        :value="SalleEquipeePour"
                        :items="getFamilyByCode('SalleEquipeePour')"
                        @change="updateOrDeleteElement($event, 'SalleEquipeePour')"
                        :item-color="primaryColor"
                        chips
                        deletable-chips
                        item-text="label"
                        no-data-text="Aucun critère ne correspond à la recherche"
                        return-object
                        multiple
                        outlined>
                        <template #selection="{ item }">
                            <v-chip :color="primaryColor" close @click:close="deleteChip(item, SalleEquipeePour, 'SalleEquipeePour')">
                                {{ item.label }}
                            </v-chip>
                        </template>
                    </v-autocomplete>
                </div>

                <div v-if="hasFamilyElement('SalleEquipement')">
                    <label :style="'color:' + fieldsColor" :class="{'required': getField('SalleEquipement').required}">
                        {{ getField('SalleEquipement').name }}
                        <help-tooltip :content="getField('SalleEquipement').helpDescription"></help-tooltip>
                    </label>
                    <v-autocomplete
                        :value="SalleEquipement"
                        :items="getFamilyByCode('SalleEquipement')"
                        @change="updateOrDeleteElement($event, 'SalleEquipement')"
                        :item-color="primaryColor"
                        chips
                        deletable-chips
                        item-text="label"
                        no-data-text="Aucun critère ne correspond à la recherche"
                        return-object
                        multiple
                        outlined>
                        <template #selection="{ item }">
                            <v-chip :color="primaryColor" close @click:close="deleteChip(item, SalleEquipement, 'SalleEquipement')">
                                {{ item.label }}
                            </v-chip>
                        </template>
                    </v-autocomplete>
                </div>

                <div v-if="hasFamilyElement('SalleRestauration')">
                    <label :style="'color:' + fieldsColor" :class="{'required': getField('SalleRestauration').required}">
                        {{ getField('SalleRestauration').name }}
                        <help-tooltip :content="getField('SalleRestauration').helpDescription"></help-tooltip>
                    </label>
                    <v-autocomplete
                        :value="SalleRestauration"
                        :items="getFamilyByCode('SalleRestauration')"
                        @change="updateOrDeleteElement($event, 'SalleRestauration')"
                        :item-color="primaryColor"
                        chips
                        deletable-chips
                        item-text="label"
                        no-data-text="Aucun critère ne correspond à la recherche"
                        return-object
                        multiple
                        outlined>
                        <template #selection="{ item }">
                            <v-chip :color="primaryColor" close @click:close="deleteChip(item, SalleRestauration, 'SalleRestauration')">
                                {{ item.label }}
                            </v-chip>
                        </template>
                    </v-autocomplete>
                </div>

                <div v-if="hasFamilyElement('SalleHebergement')">
                    <label :style="'color:' + fieldsColor" :class="{'required': getField('SalleHebergement').required}">
                        {{ getField('SalleHebergement').name }}
                        <help-tooltip :content="getField('SalleHebergement').helpDescription"></help-tooltip>
                    </label>
                    <v-autocomplete
                        :value="SalleHebergement"
                        :items="getFamilyByCode('SalleHebergement')"
                        @change="updateOrDeleteElement($event, 'SalleHebergement')"
                        :item-color="primaryColor"
                        chips
                        deletable-chips
                        item-text="label"
                        no-data-text="Aucun critère ne correspond à la recherche"
                        return-object
                        multiple
                        outlined>
                        <template #selection="{ item }">
                            <v-chip :color="primaryColor" close @click:close="deleteChip(item, SalleHebergement, 'SalleHebergement')">
                                {{ item.label }}
                            </v-chip>
                        </template>
                    </v-autocomplete>
                </div>
            </div>

            <div v-if="hasRoomCapacitiesToDisplay() || hasRoomPropertiesToDisplay()">
                <div class="tabulation-title m-auto">
                    <h5 style="font-size: 22px;" :style="'color:' + titlesColor">
                        Salles
                    </h5>
                </div>

                <div class="mt-5">
                    <div class="d-flex justify-start flex-wrap" style="margin-left: -20px; margin-right: -20px">
                        <div v-for="(room, index) in roomRenting.rooms"
                             class="mb-5 mt-5"
                             style="margin-left: 20px; margin-right: 20px">
                            <v-card width="300px">
                                <v-app-bar dark :color="primaryColor">
                                    <div class="d-flex justify-content-between w-100">
                                        <div class="mt-auto mb-auto cmaj-title">
                                            <span>{{ room.name }}</span>
                                        </div>

                                        <div class="d-flex">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn v-on="on" icon @click="prepareEdit(room)">
                                                        <v-icon dense>edit</v-icon>
                                                    </v-btn>
                                                </template>
                                                <div>Modifier</div>
                                            </v-tooltip>

                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn v-on="on" icon @click="removeRoom(index)">
                                                        <v-icon dense>close</v-icon>
                                                    </v-btn>
                                                </template>
                                                <div>Supprimer</div>
                                            </v-tooltip>
                                        </div>
                                    </div>
                                </v-app-bar>

                                <v-card-text>
                                    <div class="mt-1 justify-content-between d-flex" v-if="hasField('ROOM_DESCRIPTION')">
                                        <div><b>{{ getField('ROOM_DESCRIPTION').name }}</b></div>

                                        <div v-if="room.description !== null" style=" text-overflow: ellipsis;white-space: nowrap;overflow: hidden;max-width: 50%;">
                                            {{ room.description }}
                                        </div>
                                        <div v-else>Non renseigné</div>
                                    </div>

                                    <div class="mt-1 justify-content-between d-flex" v-if="hasField('MAX_CAPACITY_PERS')">
                                        <div><b>{{ getField('MAX_CAPACITY_PERS').name }}</b></div>

                                        <div v-if="room.max_capacity !== null">
                                            {{ room.max_capacity }}
                                        </div>
                                        <div v-else>Non renseigné</div>
                                    </div>

                                    <div class="mt-1 justify-content-between d-flex" v-if="hasField('AREA')">
                                        <div><b>{{ getField('AREA').name }}</b></div>

                                        <div v-if="room.area !== null">
                                            {{ room.area }}m²
                                        </div>
                                        <div v-else>Non renseigné</div>
                                    </div>

                                    <div class="mt-1 justify-content-between d-flex" v-if="hasField('ROOM_HEIGHT')">
                                        <div><b>{{ getField('ROOM_HEIGHT').name }}</b></div>

                                        <div v-if="room.height !== null">
                                            {{ room.height }}m
                                        </div>
                                        <div v-else>Non renseigné</div>
                                    </div>

                                    <div class="mt-1 justify-content-between d-flex" v-if="hasField('NATURAL_LIGHT')">
                                        <div><b>{{ getField('NATURAL_LIGHT').name }}</b></div>

                                        <div>
                                            {{ room.natural_light ? 'Oui' : 'Non' }}
                                        </div>
                                    </div>

                                    <div v-if="hasCapacitiesToDisplay"><b>Capacités par disposition</b></div>

                                    <div class="mt-1 justify-content-between d-flex" v-if="hasField('ROOM_U')">
                                        <div class="ml-5"><b>{{ getField('ROOM_U').name }}</b></div>

                                        <div v-if="room.u_shape_capacity !== null && room.u_shape_capacity !== ''">
                                            {{ room.u_shape_capacity }}
                                        </div>
                                        <div v-else>Non renseigné</div>
                                    </div>

                                    <div class="mt-1 justify-content-between d-flex" v-if="hasField('ROOM_BANQUET')">
                                        <div class="ml-5"><b>{{ getField('ROOM_BANQUET').name }}</b></div>

                                        <div v-if="room.banquet_capacity !== null && room.banquet_capacity !== ''">
                                            {{ room.banquet_capacity }}
                                        </div>
                                        <div v-else>Non renseigné</div>
                                    </div>

                                    <div class="mt-1 justify-content-between d-flex" v-if="hasField('ROOM_SQUARE')">
                                        <div class="ml-5"><b>{{ getField('ROOM_SQUARE').name }}</b></div>

                                        <div v-if="room.square_capacity !== null && room.square_capacity !== ''">
                                            {{ room.square_capacity }}
                                        </div>
                                        <div v-else>Non renseigné</div>
                                    </div>

                                    <div class="mt-1 justify-content-between d-flex" v-if="hasField('ROOM_CLASS')">
                                        <div><b class="ml-5">{{ getField('ROOM_CLASS').name }}</b></div>

                                        <div v-if="room.classroom_capacity !== null && room.classroom_capacity !== ''">
                                            {{ room.classroom_capacity }}
                                        </div>
                                        <div v-else>Non renseigné</div>
                                    </div>

                                    <div class="mt-1 justify-content-between d-flex" v-if="hasField('ROOM_COCKTAIL')">
                                        <div class="ml-5"><b>{{ getField('ROOM_COCKTAIL').name }}</b></div>

                                        <div v-if="room.cocktail_capacity !== null && room.cocktail_capacity !== ''">
                                            {{ room.cocktail_capacity }}
                                        </div>
                                        <div v-else>Non renseigné</div>
                                    </div>

                                    <div class="mt-1 justify-content-between d-flex" v-if="hasField('ROOM_THEATRE')">
                                        <div class="ml-5"><b>{{ getField('ROOM_THEATRE').name }}</b></div>

                                        <div v-if="room.theatre_style_capacity !== null && room.theatre_style_capacity !== ''">
                                            {{ room.theatre_style_capacity }}
                                        </div>
                                        <div v-else>Non renseigné</div>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </div>

                        <v-card width="300px"
                                min-height="382px"
                                style="margin-left: 20px; margin-right: 20px"
                                :style="'border-color:' + primaryColor + '!important'"
                                class="d-table-cell align-middle add-room-card text-center mb-5 mt-5">
                            <div class="d-inline-block w-100 room-card-box">
                                <v-btn color="rgb(33, 158, 185)"
                                       text
                                       class="text-none add-room-btn"
                                       :color="primaryColor"
                                       style="border-radius: 20px"
                                       @click="addNewRoom">
                                    <v-icon class="mr-2">add</v-icon>
                                    Ajouter une salle
                                </v-btn>
                            </div>
                        </v-card>
                    </div>
                </div>
            </div>
        </div>

        <v-dialog persistent content-class="pro-dialog" v-model="roomDialog" max-width="900px">
            <v-card>
                <v-card-title>
                    <h2 class="headline-title" v-if="!edit">Ajout d'une salle</h2>
                    <h2 class="headline-title" v-else>Modification d'une salle</h2>

                    <v-btn icon class="close-modal-icon" @click="roomDialog = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-spacer></v-spacer>
                    <div class="mt-3 text-center">
                        <room ref="room" :room="currentRoom" :required-field="false" :edit="edit"></room>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <confirm ref="confirm"></confirm>
    </div>
</template>

<script>
    import {mapGetters, mapMutations, mapState} from "vuex"
    import Room from "./Room"
    import Confirm from "../../../tools/Confirm"
    import HelpTooltip from "../../../tools/HelpTooltip";

    export default {
        name: "RoomRenting",
        components: {HelpTooltip, Confirm, Room},
        props: ['index', "newTitle", "helpDesc"],
        data() {
            return {
                SalleEquipeePour: [],
                SalleEquipement: [],
                SalleRestauration: [],
                SalleHebergement: [],
                roomDialog: false,
                edit: false,
                currentRoom: {},
            }
        },
        methods: {
            ...mapMutations('web_form', ['addElement', 'removeElement', 'updateProvider', 'deleteRoom']),
            hasFieldToDisplay() {
                return this.hasCapacitiesToDisplay() ||
                    this.hasPrestationsToDisplay() ||
                    this.hasRoomCapacitiesToDisplay() ||
                    this.hasRoomPropertiesToDisplay()
            },
            hasCapacitiesToDisplay() {
                return this.hasField('MAX_CAPACITY_ACC') ||
                    this.hasField('ROOM_NUMBER') ||
                    this.hasField('ROOM_MOD')
            },
            hasPrestationsToDisplay() {
                return this.hasFamilyElement('SalleEquipeePour') ||
                    this.hasFamilyElement('SalleEquipement') ||
                    this.hasFamilyElement('SalleRestauration') ||
                    this.hasFamilyElement('SalleHebergement')
            },
            hasRoomCapacitiesToDisplay() {
                return this.hasField('ROOM_U') ||
                    this.hasField('ROOM_BANQUET') ||
                    this.hasField('ROOM_SQUARE') ||
                    this.hasField('ROOM_CLASS') ||
                    this.hasField('ROOM_COCKTAIL') ||
                    this.hasField('ROOM_THEATRE')

            },
            hasRoomPropertiesToDisplay() {
                return this.hasField('NAME') ||
                    this.hasField('ROOM_DESCRIPTION') ||
                    this.hasField('MAX_CAPACITY_PERS') ||
                    this.hasField('AREA') ||
                    this.hasField('ROOM_HEIGHT') ||
                    this.hasField('NATURAL_LIGHT')
            },
            updateOrDeleteElement(newElements, property) {
                let currentElements = this[property]

                if(currentElements.length > newElements.length) {  // Cas suppression
                    this.deleteElement(currentElements, newElements)
                } else { // Cas Ajout
                    this.addNewElement(currentElements, newElements)
                }

                this[property] = newElements
            },
            addNewRoom() {
                let room = {
                    area: null,
                    banquet_capacity: null,
                    classroom_capacity: null,
                    cocktail_capacity: null,
                    description: null,
                    height: null,
                    max_capacity: null,
                    name: null,
                    natural_light: false,
                    square_capacity: null,
                    theatre_style_capacity: null,
                    u_shape_capacity: null,
                }

                room.uid = Math.random().toString(36).substr(2, 16)

                this.$global.$emit('init-required-fields')

                this.edit        = false
                this.currentRoom = room
                this.roomDialog  = true
            },
            deleteChip(itemNeedToRemove, array, property) {
                let newElements = JSON.parse(JSON.stringify(array))

                for (let i = 0; i < newElements.length; i += 1) {
                    if (newElements[i].id === itemNeedToRemove.id) {
                        newElements.splice(i, 1)
                    }
                }

                this.updateOrDeleteElement(newElements, property)
            },
            prepareEdit(room) {
                this.$global.$emit('init-required-fields')

                this.edit        = true
                this.currentRoom = JSON.parse(JSON.stringify(room))
                this.roomDialog  = true
            },
            removeRoom(index) {
                let message = 'Vous allez supprimer la salle'

                if(this.provider.room_renting.rooms[index].name !== null) {
                    message += ' <b>' + this.provider.room_renting.rooms[index].name + '</b>'
                }

                message += '. Êtes-vous sûr de vouloir supprimer cette salle ?'

                this.$refs.confirm.open('Attention', message,
                    { color: 'red', confirmColor: 'red', cancelColor: '#0b697e' }).
                then((confirm) => {
                    if (confirm) {
                        this.deleteRoom(index)
                    }
                })
            },
            updateRoom(room) {
                this.provider.room_renting.rooms.forEach((_room, index) => {
                    if ((_room.external_id && room.external_id && _room.external_id === room.external_id) ||
                      (_room.uid && room.uid && _room.uid === room.uid)) {
                        this.provider.room_renting.rooms[index] = room
                    }
                })
            },
            addNewElement(previousElements, newElements) {
                let element = newElements
                const previousValue = JSON.parse(JSON.stringify(previousElements))

                if (Array.isArray(newElements)) {
                    let diff = newElements.filter(_element => !previousElements.includes(_element)) || []

                    if (diff.length) {
                        element = diff[0]
                    }
                } else if (previousElements) {
                    this.removeElement(previousValue)
                }

                this.addElement(element)
            },
            deleteElement(previousElements, newElements) {
                const previousValue = JSON.parse(JSON.stringify(previousElements))

                const diff = previousElements.filter(element => {
                    return !newElements.map(elt => elt.id).includes(element.id)
                }) || []

                let element = newElements

                if (diff.length) {
                    element = diff[0]
                }

                this.removeElement(element)
            },
        },
        computed: {
            ...mapState('web_form', ['disabled', 'roomRenting', 'provider']),
            ...mapState('webFormStyle', ['fontFamily', 'primaryColor', 'titlesColor', 'fieldsColor', 'backGroundColor']),
            ...mapGetters('web_form', ['hasField', 'hasFamilyElement', 'getFamilyByCode', 'getElementsByFamilyCode',
                'getField']),
        },
        created() {
            this.SalleEquipeePour  = this.getElementsByFamilyCode('SalleEquipeePour')
            this.SalleEquipement   = this.getElementsByFamilyCode('SalleEquipement')
            this.SalleRestauration = this.getElementsByFamilyCode('SalleRestauration')
            this.SalleHebergement  = this.getElementsByFamilyCode('SalleHebergement')

            this.$global.$on('close-dialog', (room) => {
                if (room) {
                    this.updateRoom(room)
                }

                this.roomDialog = false
            })
        },
        beforeDestroy() {
            this.$global.$off('close-dialog')
        }
    }
</script>